import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import WorkspaceLayout from './components/WorkspaceLayout';
import FrameExtractor from './pages/FrameExtractor';
import ComingSoon from './pages/ComingSoon';
import About from './pages/About';

// Reset the active pane's scroll to the top on every navigation. The workspace
// shell itself doesn't scroll (each pane body does), so we target that.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.querySelector('.ws-pane-body')?.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<WorkspaceLayout />}>
          <Route path="/" element={<FrameExtractor />} />
          {/* Frame Extractor's canonical home is `/`; keep the old URL working. */}
          <Route path="/frame-extractor" element={<Navigate to="/" replace />} />
          <Route path="/sharpness-scorer" element={<ComingSoon />} />
          <Route path="/color-segmentation" element={<ComingSoon />} />
          <Route path="/object-detection" element={<ComingSoon />} />
          <Route path="/traffic-analysis" element={<ComingSoon />} />
          <Route path="/aerial-mapper" element={<ComingSoon />} />
          <Route path="/about" element={<About />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
